module.exports = __webpack_public_path__ + "files/6675ad5543936b6d8a824745ff563de0.png";